// @flow
import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  participantList: { padding: "0px !important" },
  textHeader: { 
    width: "70%",
    alignSelf: "center"
  }
}), { index: 1 })